

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BillItem, BillItemGradeYear } from '@/models/billData';
import { GradeYears } from '@/enums/gradeYears';

interface LocalBillItem {
  itemId: number;
  itemName: string;
  gradeYear: GradeYears;
  unitPrice: number;
  nonTaxable: boolean;
}

@Component({})
export default class BillItemTable extends Vue {
  @Prop({ type: Array, required: true })
  public billItems!: BillItem[];

  private localBillItems: LocalBillItem[] = [];

  public created() {
    this.localBillItems = this.billItems.reduce((list, item) => {
      const data: LocalBillItem[] = item.gradeYearItems.map((gradeYearItem) => ({
        itemId: item.itemId,
        itemName: item.itemName,
        nonTaxable: item.nonTaxable,
        gradeYearId: '',
        gradeYear: gradeYearItem.gradeYear,
        unitPrice: gradeYearItem.unitPrice,
      }));
      list.push(...data);
      return list;
    }, new Array<LocalBillItem>());
  }

  private spanRow({ row, column, rowIndex, columnIndex }
    : { row: BillItem, column: { property: string }, rowIndex: number, columnIndex: number }) {
    switch (column.property) {
      case 'itemName':
      case 'nonTaxable':
        const index = this.localBillItems.findIndex((item) => item.itemId === row.itemId);
        if (index === rowIndex) {
          const count = this.localBillItems.filter((item) => item.itemId === row.itemId).length;
          return {
            rowspan: count,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 1,
          };
        }
    }
  }

  private checkDuplicateGradeYear(row: LocalBillItem): boolean {
    return this.localBillItems.filter((item) =>
      item.itemId === row.itemId && item.gradeYear === row.gradeYear
    ).length >= 2;
  }

  private onItemAdd() {
    const min = Math.min(0,
      ...this.localBillItems.filter((w) => w.itemId < 0)
        .map((item) => item.itemId)
    );
    this.localBillItems.push({
      itemId: min - 1,
      itemName: '',
      gradeYear: GradeYears.All,
      unitPrice: 0,
      nonTaxable: false,
    });
  }

  private onGradeYearAdd(row: LocalBillItem) {
    const itemIndex = this.localBillItems.indexOf(row);
    this.localBillItems.splice(itemIndex + 1, 0, {
      ...row,
    });
  }

  private onGradeYearDelete(row: LocalBillItem) {
    const itemIndex = this.localBillItems.indexOf(row);
    this.localBillItems.splice(itemIndex, 1);
  }

  private onRegister() {
    const items: BillItem[] = this.localBillItems.reduce((list, item) => {
      const gradeYearItem: BillItemGradeYear = {
        gradeYear: item.gradeYear,
        unitPrice: item.unitPrice,
      };
      const currentItem = list.find((listItem) => listItem.itemId === item.itemId);
      if (currentItem) {
        currentItem.gradeYearItems.push(gradeYearItem);
      } else {
        list.push({
          itemId: item.itemId,
          itemName: item.itemName,
          nonTaxable: item.nonTaxable,
          gradeYearItems: [
            gradeYearItem
          ]
        });
      }
      return list;
    }, new Array<BillItem>());
    this.$emit('register', items);
  }
}
